
import ProductBasicStrategy from './ProductBasicStrategy'
import ProductFanStrategy from './ProductFanStrategy'
import ProductPumpStrategy from './ProductPumpStrategy'

const strategies = [ProductBasicStrategy, ProductFanStrategy, ProductPumpStrategy]

const getStrategy = (categoryCode, methodName, data) => {
  const customStrategy = strategies.find((x) => x.getCategoryCode() === categoryCode)
  if (customStrategy && customStrategy[methodName]) {
    return customStrategy[methodName](data)
  }
  if (ProductBasicStrategy[methodName]) {
    return ProductBasicStrategy[methodName](data)
  }
  return null
}

const actions = {
  getCurveFormItems(categoryCode, data) {
    return getStrategy(categoryCode, 'getCurveFormItems', data)
  },
  getSearchProperties(categoryCode, { aggProperties }) {
    return getStrategy(categoryCode, 'getSearchProperties', { aggProperties })
  },
  getColumns(categoryCode, { allProperties, curveProperties }) {
    return getStrategy(categoryCode, 'getColumns', { allProperties, curveProperties })
  },
  getTableData(categoryCode, { products, allProperties, samplesMapping }) {
    return getStrategy(categoryCode, 'getTableData', { products, allProperties, samplesMapping })
  },
  getDesignProperties(categoryCode, { allProperties, curveProperties, row, isSingleSpeed, emptyValue }) {
    return getStrategy(categoryCode, 'getDesignProperties', { allProperties, curveProperties, row, isSingleSpeed, emptyValue })
  },
  getRunTimeProperties(categoryCode, { allProperties, curveProperties, row, isSingleSpeed }) {
    return getStrategy(categoryCode, 'getRunTimeProperties', { allProperties, curveProperties, row, isSingleSpeed })
  }
}
export default {
  namespaced: true,
  ...actions
}
